export default "__VITE_ASSET__DSrln$fb__"